import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { Avatar } from '@/components/ui/Avatar';
import { SQIcon } from '@/components/ui/SQIcon';
import { colorForPlayer } from '@/utils/colorForPlayer';
import styles from './OpponentProgress.module.css';

export const OpponentProgress = observer(function OpponentProgress() {
  const { round } = useStore();
  const { opponents, progressVisibility } = round;

  if (!opponents.length) return null;

  if (progressVisibility === 'Hidden') {
    return <p className={styles.hidden}>Соперники скрыты</p>;
  }

  return (
    <div className={styles.strip}>
      {opponents.map(o => (
        <div
          key={o.playerId}
          className={`${styles.pill} ${!o.isConnected ? styles.offline : ''}`}
        >
          <Avatar
            name={o.nickname}
            color={colorForPlayer(o.playerId)}
            size={32}
            dim={!o.isConnected}
          />
          <div className={styles.info}>
            <div className={styles.nameRow}>
              <span className={`${styles.name}${!o.isConnected ? ` ${styles.nameLeft}` : ''}`}>
                {o.nickname}
              </span>
              {!o.isConnected && (
                <SQIcon name="door" size={12} aria-label="покинул игру" />
              )}
            </div>
            <span className={styles.score}>
              {progressVisibility === 'Score'
                ? `${o.totalScore ?? 0} оч`
                : `${o.wordCount ?? 0} сл`}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
});
